module.exports = __webpack_public_path__ + "img/new-people-jet-employee.3a7b8db7.png";